import { inject as l, computed as i, shallowRef as f } from "vue";
import { configProviderInjectionKey as t } from "./ghl-ui.es949.js";
const u = "n";
function a(r = {}, m = {
  defaultBordered: !0
}) {
  const e = l(t, null);
  return {
    // NConfigProvider,
    inlineThemeDisabled: e == null ? void 0 : e.inlineThemeDisabled,
    mergedRtlRef: e == null ? void 0 : e.mergedRtlRef,
    mergedComponentPropsRef: e == null ? void 0 : e.mergedComponentPropsRef,
    mergedBreakpointsRef: e == null ? void 0 : e.mergedBreakpointsRef,
    mergedBorderedRef: i(() => {
      var d, o;
      const {
        bordered: n
      } = r;
      return n !== void 0 ? n : (o = (d = e == null ? void 0 : e.mergedBorderedRef.value) !== null && d !== void 0 ? d : m.defaultBordered) !== null && o !== void 0 ? o : !0;
    }),
    mergedClsPrefixRef: e ? e.mergedClsPrefixRef : f(u),
    namespaceRef: i(() => e == null ? void 0 : e.mergedNamespaceRef.value)
  };
}
function g() {
  const r = l(t, null);
  return r ? r.mergedClsPrefixRef : f(u);
}
export {
  a as default,
  u as defaultClsPrefix,
  g as useMergedClsPrefix
};
